var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-spinner"},[_c('hollow-dots-spinner',{attrs:{"animation-duration":1000,"dot-size":_vm.size,"dots-num":3,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }